export enum PopupTypeEnum {
    UNIT = 'UNIT',
    MULTIMEDIA = 'MULTIMEDIA',
    TEXT = 'TEXT',
}
